import React from 'react';
const stats = [{
  num: '+15K',
  label: 'Eine Gemeinschaft von über 15.000 Lehrern 🌍, die ihre Methode transformiert haben.'
}, {
  num: '1.200+',
  label: 'Yoga-Studios und Freelancer in Deutschland nutzen es bereits täglich.'
}, {
  num: '380K+',
  label: 'Heruntergeladene Sequenzen seit Jahresbeginn.'
}, {
  num: '94%',
  label: 'Ersparnis von über 5 Stunden Planungszeit pro Woche.'
}];
const standards = ['Entwickelt für Lehrer von Hatha, Vinyasa und therapeutischem Yoga.', 'Stufen-System A/B/C: Varianten für Anfänger, Mittelstufe und Fortgeschrittene.', 'Kompatibel mit Tablet, Smartphone, PC und bereit für hochauflösenden Druck.'];
export function TrustBar() {
  return <section className="w-full bg-bg-alt py-12 sm:py-16 border-y border-border-light px-4 relative overflow-hidden" data-id="element-281">
      <div className="absolute inset-0 bg-gradient-to-r from-transparent via-primary/5 to-transparent" data-id="element-282"></div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-283">
        <p className="text-center text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-8" data-id="element-284">
          Unsere deutsche Community
        </p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8 mb-10 sm:mb-12" data-id="element-285">
          {stats.map((stat, i) => <div key={i} className="text-center" data-id="element-286">
              <div className="text-primary font-black text-2xl sm:text-4xl mb-2 drop-shadow-[0_0_8px_rgba(168,85,247,0.5)]" data-id="element-287">
                {stat.num}
              </div>
              <p className="text-text-sec text-xs sm:text-sm leading-snug" data-id="element-288">
                {stat.label}
              </p>
            </div>)}
        </div>

        <div className="border-t border-border-light pt-8 sm:pt-10" data-id="element-289">
          <p className="text-center text-primary font-bold uppercase tracking-wider text-xs sm:text-sm mb-5" data-id="element-290">
            Professioneller Elite-Standard
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 sm:gap-6" data-id="element-291">
            {standards.map((s, i) => <div key={i} className="flex items-start gap-3 bg-white/5 border border-white/10 rounded-xl px-4 py-3" data-id="element-292">
                <span className="text-check-green text-sm mt-0.5" data-id="element-293">✓</span>
                <p className="text-text-sec text-sm leading-snug" data-id="element-294">{s}</p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}